//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DonateBlock',

  data() {
    return {
      donaters: [],
      form: {
        name: '',
        amount: 0,
        email: '',
        return_url: '',
      },
      validators: {
        name: {
          trigger: 'blur',
          required: true,
          validator: (rule, value, callback) => {
            if (value.length === 0) {
              return callback(new Error('Поле обязательное'))
            }
            if (value.length > 40) {
              return callback(new Error('Не более 40 символов'))
            }
            return callback()
          }
        },
        email: {
          trigger: 'blur',
          required: true,
          validator: (rule, value, callback) => {
            if (value.length === 0) {
              return callback(new Error('Поле обязательное'))
            }
            if (value.length > 40) {
              return callback(new Error('Не более 40 символов'))
            }

            if (!value.includes('@')) {
              return callback(new Error('Email должен содержать символ @'))
            }

            const parts = value.split('@')
            if (parts.length > 2) {
              return callback(new Error('Email может содержать только один символ @'))
            }

            const [localPart, domainPart] = parts

            if (localPart.length === 0) {
              return callback(new Error('Введите имя пользователя перед @'))
            }

            if (domainPart.length === 0) {
              return callback(new Error('Введите домен после @'))
            }

            if (!domainPart.includes('.')) {
              return callback(new Error('Домен должен содержать точку (например: mail.ru)'))
            }

            if (domainPart.startsWith('.') || domainPart.endsWith('.')) {
              return callback(new Error('Домен не может начинаться или заканчиваться точкой'))
            }

            if (value.includes('..')) {
              return callback(new Error('Email не может содержать две точки подряд'))
            }

            if (value.includes(' ')) {
              return callback(new Error('Email не может содержать пробелы'))
            }

            return callback()
          }
        },
        amount: {
          trigger: 'blur',
          required: true,
          validator: (rule, value, callback) => {
            if (value === 0) {
              return callback(new Error('Число должно быть больше 0'))
            }
            if (!value) {
              return callback(new Error('Поле обязательное'))
            }
            return callback()
          }
        },
      },
    }
  },
  watch: {
    $route(to) {
      if (
        to &&
        to.query &&
        (to.query.thanks === 'true' || to.query.thanks === true)
      ) {
        let timer;
        timer = setTimeout(() => {
          this.$modal.success({ title: 'Спасибо за вашу поддержку!', content:'Скоро ваше имя появится в списке благотворителей энциклопедии' });
          this.removeThanksParam();

          timer = clearTimeout(timer);
        }, 1000);
      }
    }
  },

  async mounted() {
    if (
      this.$route &&
      this.$route.query &&
      (this.$route.query.thanks === 'true' || this.$route.query.thanks === true)
    ) {
      let timer;
      timer = setTimeout(() => {
        this.$modal.success({ title: 'Спасибо за вашу поддержку!', content:'Скоро ваше имя появится в списке благотворителей энциклопедии' });
        this.removeThanksParam();

        timer = clearTimeout(timer);
      }, 1000);
    }

    try {
      const response = await this.$axios.$get(`${process.env.BASE_URL_V2}/public/footer/random_supporters/`);
      this.donaters = response.items;
    } catch(err) {
      console.error(err);
    }
  },

  methods: {
    removeThanksParam() {
      const query = { ...this.$route.query };
      if (query.thanks !== undefined) {
        delete query.thanks;
        this.$router.replace({ path: this.$route.path, query, hash: this.$route.hash }).catch(() => {});
      }
    },
    onSelectPrice(value) {
      this.form.amount = value;
    },
    handleSubmit: function (e) {
      e.preventDefault();

      this.$refs.form.validate(async (isValid) => {
        if (!isValid) return
        const payload = { ...this.form };
        payload.return_url = window.location.origin + window.location.pathname + '?thanks=true';

        try {
          await this.$axios.post(`${process.env.BASE_URL_V2}/public/footer/donate/`, payload)
            .then(response => {
              if (response.data && response.data.confirmation_url) {
                let timer;
                timer = setTimeout(() => {
                  window.location.href = response.data.confirmation_url;

                  timer = clearTimeout(timer);
                }, 500);
              }
            });
        } catch(err) {
          console.error(err);
        }

      })
    },
  }
}
